var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 8 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 6L0.535899 -6.52533e-07L7.4641 -4.68497e-08L4 6Z","fill":"black"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }